"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const index_1 = __importDefault(require("../../index"));
const PageRendererWrapper_1 = __importDefault(require("./components/PageRendererWrapper"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const useOnBackPress_1 = __importDefault(require("../../hooks/useOnBackPress"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const valueIsStatusBarStyle_1 = __importDefault(require("../../../typeAssertions/valueIsStatusBarStyle"));
const PageContext_1 = __importDefault(require("../../../PageBooter/PageContext"));
const SideMenuWrapperRenderer_1 = __importDefault(require("../SideMenuWrapperRenderer"));
const BottomMenuSheetWrapperRenderer_1 = __importDefault(require("../BottomMenuSheetWrapperRenderer"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const PageRenderAdditionalElementsContext_1 = __importDefault(require("../../../PageRenderAdditionalElementsContext"));
const PageRenderer = ({ page, }) => {
    var _a, _b;
    const { Render, dimentions, getColorFromSpecification, functions: { processor, listenerBackHandler }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const insidePageElement = (0, react_1.useContext)(PageRenderAdditionalElementsContext_1.default);
    const { isFocused } = (0, react_1.useContext)(PageContext_1.default);
    const events = (0, useControlEvents_1.default)(page);
    (0, useOnLoad_1.default)(page, events, isFocused);
    const firstLoadExecutedFlagRef = (0, react_1.useRef)(false);
    const onFirstLoadEvent = events.onFirstLoad;
    (0, react_1.useEffect)(() => {
        if (onFirstLoadEvent && isFocused && !firstLoadExecutedFlagRef.current) {
            firstLoadExecutedFlagRef.current = true;
            onFirstLoadEvent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page.id, isFocused]);
    (0, useOnBackPress_1.default)(page, events, listenerBackHandler);
    const isAndroid = processor.root.platformOS === 'android';
    const safeAreaStyle = (0, react_1.useMemo)(() => {
        var _a;
        const computed = {
            flex: 1,
            width: '100%',
        };
        if ((_a = page.style) === null || _a === void 0 ? void 0 : _a.background) {
            computed.backgroundColor = getColorFromSpecification(page.style.background);
        }
        if (!computed.backgroundColor
            || computed.backgroundColor === 'transparent') {
            computed.backgroundColor = 'white';
        }
        if (isAndroid
            && dimentions.statusBarHeight
            && dimentions.statusBarHeight <= 24
            && !page.statusBarHidden) {
            computed.height = dimentions.window.height - dimentions.statusBarHeight;
            delete computed.flex;
        }
        return computed;
    }, [
        getColorFromSpecification,
        page.statusBarHidden,
        page.style,
        dimentions.window.height,
        dimentions.statusBarHeight,
        isAndroid,
    ]);
    const barStyle = (0, react_1.useMemo)(() => {
        if ((0, valueIsStatusBarStyle_1.default)(page.statusBarStyle)) {
            return page.statusBarStyle;
        }
        return 'default';
    }, [page.statusBarStyle]);
    return (react_1.default.createElement(Render.SafeAreaView, { style: safeAreaStyle },
        isFocused && (react_1.default.createElement(Render.StatusBar, { hidden: !!page.statusBarHidden, barStyle: barStyle, backgroundColor: ((_a = page.style) === null || _a === void 0 ? void 0 : _a.statusBarColor)
                ? getColorFromSpecification((_b = page.style) === null || _b === void 0 ? void 0 : _b.statusBarColor)
                : undefined })),
        react_1.default.createElement(Render.RotationLock, { rotation: page.rotation }),
        react_1.default.createElement(PageRendererWrapper_1.default, { page: page }, page.controls && (page.controls).map((child) => (react_1.default.createElement(index_1.default, { key: child.id, control: child, parent: page })))),
        page.bottomMenuSheet && (react_1.default.createElement(BottomMenuSheetWrapperRenderer_1.default, { page: page },
            react_1.default.createElement(index_1.default, { control: page.bottomMenuSheet, parent: page }))),
        page.sideMenu && (react_1.default.createElement(SideMenuWrapperRenderer_1.default, null)),
        isFocused && insidePageElement));
};
exports.default = PageRenderer;
